import { Component } from '@angular/core';

@Component({
  selector: 'app-form-zones',
  templateUrl: './form-zones.component.html',
  styleUrls: ['./form-zones.component.scss']
})
export class FormZonesComponent {

}
